import React from "react";
import { useState, useEffect } from "react";
import Price from "../../../Price";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const ConfigurationOptionsForType = ({
  baseProductId,
  category,
  products,
  canMixPartCodes,
  maxUnitCount,
  onUpdatedSelection,
  savedSelectedProducts,
  index,
  expandItem,
  onSelectedMaxOptions,
  id,
}) => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectionMsg, setSelectionMsg] = useState("");
  const [ttlUnitCount, setTTLUnitCount] = useState(0);
  const [shouldSetSavedSelectedProducts, setShouldSetSavedSelectedProducts] =
    useState(false);
  let inputType = maxUnitCount > 1 && canMixPartCodes ? "checkbox" : "radio";
  const [isExpanded, setIsExpanded] = useState(expandItem);

  useEffect(() => {
    let timeout = 0;
    if (!isExpanded) {
      //Only expand it if its not already (do not close it)
      setIsExpanded(expandItem);
    }
  }, [expandItem]);

  useEffect(() => {
    if (savedSelectedProducts) {
      //A delay is needed so all onUpdateSelections are called and given time to process.
      setTimeout(() => {
        setShouldSetSavedSelectedProducts(true);
      }, index * 1000);
    }
  }, []);

  useEffect(() => {
    console.log("selectedProducts update", selectedProducts);
    // let selectedProductObjects = [];
    // selectedProducts.forEach((selectedProductId) => {
    //   let product = products.filter((product) => {
    //     return product.id == selectedProductId;
    //   })[0];
    //   selectedProductObjects.push(product);
    // });

    //Keep track of ttl unit counts
    let ttlQty = selectedProducts.reduce((previousValue, currentProduct) => {
      return previousValue + parseInt(currentProduct.qty);
    }, 0);

    setTTLUnitCount(ttlQty);

    onUpdatedSelection(category, selectedProducts);
  }, [selectedProducts]);

  useEffect(() => {
    if (ttlUnitCount > maxUnitCount) {
      // alert(
      //   "Please ensure your selection is valid. You have selected more options than possible for this category."
      // );
      console.error(
        "Please ensure your selection is valid. You have selected more options than possible for this category."
      );
    }
    if (
      ttlUnitCount > 0 &&
      (ttlUnitCount === maxUnitCount || ttlUnitCount > maxUnitCount)
    ) {
      onSelectedMaxOptions && onSelectedMaxOptions();
    }
    console.log("ttlUnitCOunt updated", ttlUnitCount, maxUnitCount);
  }, [ttlUnitCount]);

  useEffect(() => {
    if (savedSelectedProducts && savedSelectedProducts.length > 0) {
      console.log(
        "savedSelectedProducts passed",
        savedSelectedProducts,
        "products",
        products
      );
      let newSelectedProducts = [...savedSelectedProducts]; //[...selectedProducts];

      //Map to the actual selection products so we have all data and its consistent with as if we added it afresh.
      newSelectedProducts = newSelectedProducts.map((selectedProduct) => {
        let foundProduct = products.find((product) => {
          return selectedProduct.bcId == product.id;
        });
        if (foundProduct) {
          foundProduct.qty = selectedProduct.qty;
        }
        return foundProduct;
      });

      console.log("setSelectedProducts", newSelectedProducts);
      setSelectedProducts(newSelectedProducts);
    }
  }, [shouldSetSavedSelectedProducts]);

  let onRadioChangeValue = (e) => {
    // alert("change");
    console.log("onRadioChangeValue onChangeValue", e.target.value);
    let product = products.find((product) => {
      console.log("onRadioChangeValue Looking for product", product);
      return product.id == e.target.value;
    });
    if (!product) {
      console.warn("No product found for", e.target.value, "in", products);
      return false;
    }
    product.qty = 1;
    console.log("onRadioChangeValue Select product", product);
    setSelectedProducts([product]);
  };

  let addProductToSelectionById = (productId) => {
    let product = products.find((product) => {
      console.log("Looking for product", product);
      return product.id == productId;
    });

    product = { ...product, qty: 1, isChecked: true };

    if (ttlUnitCount === maxUnitCount) {
      product.qty = 0;
    }
    // product.qty = 1;
    // product.isChecked = true;
    console.log("product", product, productId);
    // validateQty(product, product.qty);
    setSelectedProducts([...selectedProducts, product]);
  };

  let removeProductFromSelectionById = (productId) => {
    setSelectedProducts(
      selectedProducts.filter((product) => {
        return product.id != productId;
      })
    );
  };

  let onCheckboxChangeValue = (e) => {
    console.log("e.target.value", e.target.value, e.target.checked);
    if (e.target.checked) {
      addProductToSelectionById(e.target.value);
    } else {
      removeProductFromSelectionById(e.target.value);
    }
  };

  let validateQty = (product, qty) => {
    qty = parseInt(qty);
    // console.log("validateQty", product, qty, selectedProducts);
    if (qty > 0) {
      let ttlQty = selectedProducts.reduce((previousValue, currentItem) => {
        if (currentItem.id == product.id) {
          return previousValue;
        }
        return previousValue + parseInt(currentItem.qty);
      }, 0);
      console.log("validateQty", selectedProducts, product, ttlQty, qty);
      if (ttlQty + qty > maxUnitCount) {
        alert(
          "Sorry you can only have up to " +
            maxUnitCount +
            " within this category. Please update your selections."
        );
      }

      //TODO find product in selected products if exists then update that instead of always pushing new which creates duplicates.

      console.log("ttlQty", ttlQty);

      // setSelectedProducts([...selectedProducts, { ...product, qty }]);
    } else {
      setSelectedProducts(
        selectedProducts.filter((selectedProduct) => {
          return selectedProduct.id != product.id;
        })
      );
    }
  };

  let onSelectChangeValue = (product, qty) => {
    console.log("onSelectChangeValue", product, qty);
    qty = parseInt(qty);
    let newSelectedProducts = [...selectedProducts];

    //Remove option
    if (qty === 0) {
      newSelectedProducts = newSelectedProducts.filter((selectedProduct) => {
        return selectedProduct.id != product.id;
      });
    } else {
      //Or update its quantity
      newSelectedProducts.map((selectedProduct) => {
        if (product.id == selectedProduct.id) {
          selectedProduct.qty = qty;
        }
      });
    }
    setSelectedProducts(newSelectedProducts);
  };

  useEffect(() => {
    console.log("products", products);
    console.log(category, maxUnitCount);
    let msg = "";
    if (maxUnitCount > 1) {
      msg = `Can select up to ${maxUnitCount}`;
      if (canMixPartCodes) {
        msg += ` items and can mix and match.`;
      } else {
        msg += ` of the same item only.`;
      }
    } else {
      msg = `Choose 1 option.`;
    }
    setSelectionMsg(msg);
  }, []);
  const isSelected = (productId) => {
    let yes = selectedProducts.find((selectedProduct) => {
      return selectedProduct.id == productId;
    });
    // console.log("isSelected", productId, selectedProducts, yes);
    return yes;
    //selectedProducts.indexOf(productId.toString()) > -1;
  };

  const renderQtyOptions = (product) => {
    let optionsJSX = [];
    let selectedProduct = selectedProducts.find((selectedProduct) => {
      //Use the product from selected products as opposed to the passed down products
      return selectedProduct.id == product.id;
    });
    let ttlQtyToShow = maxUnitCount - ttlUnitCount + selectedProduct.qty;
    // if (selectedProduct.qty > ttlQtyToShow) {
    //   ttlQtyToShow = selectedProduct.qty;
    // }
    for (let i = 0; i <= ttlQtyToShow; i++) {
      optionsJSX.push(
        <option value={i} selected={selectedProduct.qty == i}>
          {i}
        </option>
      );
    }

    return optionsJSX;
  };

  return (
    <div id={id}>
      {/* <div>
        <h4>User selection: ({selectedProducts.length})</h4>
        {selectedProducts.map((selectedProduct) => {
          return selectedProduct;
        })}
      </div> */}
      <div
        className="sb-hover"
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
        style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
      >
        {/* <div
          style={{
            padding: "15px",
            paddingLeft: "0px",
          }}
        >
          {!isExpanded ? (
            <FontAwesomeIcon icon={faChevronRight} size="lg"></FontAwesomeIcon>
          ) : (
            <FontAwesomeIcon icon={faChevronDown}></FontAwesomeIcon>
          )}
        </div> */}
        <div>
          {category.image_url && (
            <div
              style={{
                display: "inline-block",
                width: "36px",
                height: "36px",
                marginRight: "10px",
                marginTop: "4px",
                backgroundImage: "url(" + category.image_url + ")",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
              }}
              src={category.image_url}
            ></div>
          )}
        </div>
        <div>
          <h1
            style={{
              fontWeight: "bold",
              display: "inline-block",
              margin: "0px",
            }}
          >
            {category.name}
          </h1>
        </div>
      </div>
      <p>{selectionMsg}</p>
      <p>(Currently selected {ttlUnitCount} options.)</p>
      {/* {isExpanded && ( */}
      <div>
        {inputType === "checkbox" &&
          products.map((product) => {
            return (
              <div
                className={`${
                  isSelected(product.id) ? "is-selected" : ""
                } sb-config-option`}
                key={product.id}
              >
                <label>
                  <input
                    type={inputType}
                    name={`${baseProductId}-${category.id}`}
                    value={product.id}
                    onChange={onCheckboxChangeValue}
                    checked={isSelected(product.id)}
                  />
                  {/* &nbsp; */}
                  {isSelected(product.id) && (
                    <span>
                      {/* &nbsp; */}
                      <select
                        name="qty"
                        style={{ width: "37px", marginRight: "10px" }}
                        onChange={(e) => {
                          onSelectChangeValue(product, e.target.value);
                        }}
                      >
                        {renderQtyOptions(product)}
                      </select>
                    </span>
                  )}
                  {/* &nbsp; */}
                  {product.name}
                  {/* &nbsp;|&nbsp; */}
                  <Price value={product.price} />
                </label>
              </div>
            );
          })}
        {inputType === "radio" &&
          products.map((product) => {
            return (
              <div
                onChange={onRadioChangeValue}
                key={product.id}
                className={`${
                  isSelected(product.id) ? "is-selected" : ""
                } sb-config-option`}
              >
                <label>
                  <input
                    type={inputType}
                    name={`${baseProductId}-${category.id}`}
                    value={product.id}
                    defaultChecked={isSelected(product.id)}
                    // checked={isSelected(product.id)}
                  />
                  {/* &nbsp; */}
                  {!canMixPartCodes &&
                    maxUnitCount > 1 &&
                    isSelected(product.id) && (
                      <span>
                        {/* &nbsp; */}
                        <select
                          name="qty"
                          style={{ width: "37px", marginRight: "10px" }}
                          onChange={(e) => {
                            onSelectChangeValue(product, e.target.value);
                          }}
                        >
                          {renderQtyOptions(product)}
                        </select>
                      </span>
                    )}
                  {/* &nbsp; */}
                  {product.name}
                  {/* &nbsp;|&nbsp; */}
                  <Price value={product.price} />
                </label>
              </div>
            );
          })}
      </div>
      {/* )} */}
      <hr />
    </div>
  );
};

export default ConfigurationOptionsForType;
